import React from 'react';
import { ListItem } from '@mui/material';
import { MenuItem } from '#component/general/mobile-drawer-menu/styles';

const DrawerMenuItem = props => {
  const {
    ItemName,
    onClickItem,
    ItemIcon
  } = props;

  return (
    <ListItem onClick={onClickItem}>
      {ItemIcon}
      <MenuItem primary={ItemName} />
    </ListItem>
  );
};

export default DrawerMenuItem;
